import { orient } from '@chakra-ui/theme-tools';
var baseStyleTrack = {
  borderRadius: 'sm',
  bg: 'gray.300'
};

var baseStyle = props => ({
  track: baseStyleTrack,
  thumb: {
    borderRadius: 'none',
    bg: 'none',
    boxShadow: 'none',
    border: 'none',
    borderColor: 'transparent',
    color: 'brand.500',
    transition: 'transform 0.2s',
    zIndex: 1,
    _focus: {
      boxShadow: 'none'
    },
    _disabled: {
      bg: 'gray.300'
    }
  },
  container: {
    '&::before, &::after': {
      display: props.orientation === 'vertical' ? 'none' : 'inline-block',
      position: 'absolute',
      content: '""',
      borderRadius: 'sm',
      bg: 'gray.300',
      top: '20%',
      height: '60%'
    },
    '&::before': {
      right: 0
    },
    '&::after': {
      left: 0
    }
  }
});

function sizeLg(props) {
  return {
    thumb: {
      w: '35px',
      h: '40px'
    },
    track: orient({
      orientation: props.orientation,
      horizontal: {
        h: '4px'
      },
      vertical: {
        w: '4px'
      }
    }),
    container: {
      '&::before, &::after': {
        width: '4px'
      }
    }
  };
}

function sizeMd(props) {
  return {
    thumb: {
      w: '30px',
      h: '35px'
    },
    track: orient({
      orientation: props.orientation,
      horizontal: {
        h: '2px'
      },
      vertical: {
        w: '2px'
      }
    }),
    container: {
      '&::before, &::after': {
        width: '2px'
      }
    }
  };
}

function sizeSm(props) {
  return {
    thumb: {
      w: '20px',
      h: '25px'
    },
    track: orient({
      orientation: props.orientation,
      horizontal: {
        h: '2px'
      },
      vertical: {
        w: '2px'
      }
    }),
    container: {
      '&::before, &::after': {
        width: '2px'
      }
    }
  };
}

var sizes = {
  lg: sizeLg,
  md: sizeMd,
  sm: sizeSm
};
var defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
export default {
  baseStyle,
  defaultProps,
  sizes
};
//# sourceMappingURL=Slider.js.map